import React, { useState, useEffect } from 'react';
import styles from './SearchBar.module.css';

type SearchBarProps = {
    placeholder?: string;
    onSearch?: (query: string) => void;
    onChange?: (query: string) => void;
    value?: string;
    showClearButton?: boolean;
    icon?: React.ReactNode;
};

const SearchBar: React.FC<SearchBarProps> = ({
    placeholder = 'Search...',
    onSearch = () => { },
    onChange,
    value,
    showClearButton = true,
    icon = <img src="/assets/icons/magnifier-b.png" alt="magnifier" />
}) => {
    // Support both controlled and uncontrolled modes
    const [internalQuery, setInternalQuery] = useState('');
    const query = value !== undefined ? value : internalQuery;

    // Sync internal state with controlled value
    useEffect(() => {
        if (value !== undefined) {
            setInternalQuery(value);
        }
    }, [value]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        setInternalQuery(newValue);

        // Call onChange for real-time filtering
        if (onChange) {
            onChange(newValue);
        }
    };

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            onSearch(query);
        }
    };

    const handleClear = () => {
        setInternalQuery('');
        if (onChange) {
            onChange('');
        }
        onSearch('');
    };

    return (
        <div className={styles.searchBarContainer}>
            <div className={styles.searchIcon}>{icon}</div>
            <input
                type="text"
                className={styles.searchInput}
                placeholder={placeholder}
                value={query}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                maxLength={100}
            />
            {showClearButton && query && (
                <button
                    type="button"
                    className={styles.clearButton}
                    onClick={handleClear}
                    aria-label="Clear search"
                >
                    ×
                </button>
            )}
        </div>
    );
};

export default SearchBar;
